import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export const getWorkshops = async () => {
  try {
    if (!functions) {
      throw new Error("Firebase functions not initialized");
    }
    const workshopsServiceCallable = httpsCallable<unknown, any>(functions, 'workshopsService');
    const result = await workshopsServiceCallable({
      action: "getWorkshops",
      data: {}
    });
    let data = result.data;
    if (Array.isArray(data)) {
      return data;
    }
    if (data && typeof data === 'object') {
      if (Array.isArray(data.workshops)) return data.workshops;
      if (Array.isArray(data.data)) return data.data;

      const values = Object.values(data);
      if (values.length > 0 && values.every(v => v && typeof v === 'object')) {
        return values;
      }
    }
    return [];
  } catch (error) {
    console.error('Error fetching workshops:', error);
    throw error;
  }
};

export const getWorkshopById = async (id: string) => {
  try {
    if (!functions) {
      throw new Error("Firebase functions not initialized");
    }
    const workshopsServiceCallable = httpsCallable<unknown, any>(functions, 'workshopsService');
    const result = await workshopsServiceCallable({
      action: "getWorkshopById",
      data: { id }
    });
    return result.data;
  } catch (error) {
    console.error('Error fetching workshop:', error);
    throw error;
  }
};